// extracted by mini-css-extract-plugin
export default {"NoDataComp":"NoDataComp_NoDataComp__39Hpp"};